import React from "react";
import getYouTubeID from "get-youtube-id";

import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";

const VideoEmbed = ({ data }) => {
  let videosrc = data?.EmbedLink;
  var id = getYouTubeID(videosrc, { fuzzy: false });
  console.info(id);
  return (
    <section className="my-14  max-w-screen-xl xxl:max-w-screen-3xl  mx-auto  player-wrapper">
      <LiteYouTubeEmbed
        id={id}
        width="100%"
        height="100%"
        poster="maxresdefault"
        className="react-player"
        // style={{maxHeight:"659"}}
      />
    </section>
  );
};

export default VideoEmbed;
